/**
 * Split feature flags and their treatments used during local development and testing in this application
 */

export const SPLIT_GATEWAY_MONITORING = "gateway-monitoring-monorepo-06-20-24";
export const SPLIT_RESEARCH_ASSISTANT =
  "research-assistant-full-page-app-release-04-09-2024";
export const SPLIT_EMAIL_VIEWER = "mdc-notifications-email-viewer-2024-07-10";
export const SPLIT_ALERT_BANNER = "core-alert-banner-2024-10-10";
export const SPLIT_NOTIFICATION_SETTINGS =
  "mdc-notifications-enable-settings-page-2025-01-03";
export const SPLIT_LOGIN_MAP_REDIRECTION = "mdc-login-map-redirection-01-29-25";
export const SPLIT_PROFILE_PAGE =
  "MDCPT-54626-split-flag-profile-page-accounts-mfe-03-25-2025";
export const SPLIT_PERSON_ICON = "Mdc-Shell-Toggle-Person-Icon-2025-04-09";

export const SPLIT_TEST_FEATURES = {
  [SPLIT_GATEWAY_MONITORING]: "on",
  [SPLIT_RESEARCH_ASSISTANT]: "on",
  [SPLIT_ALERT_BANNER]: "on",
  [SPLIT_NOTIFICATION_SETTINGS]: "on",
  [SPLIT_PROFILE_PAGE]: "on",
  [SPLIT_PERSON_ICON]: "off",
};
